import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';
import { getLocationBuildingFloorsById } from './LocationDetailPage';
import { getPointOfInterestTypes } from './MapPage';

export function getLocations(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_DIRECTIONS_LOCATIONS_REQUEST,
			payload: { loading_locations: true }
		});

		const response = await API.directions.getLocations({ ...options });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DIRECTIONS_LOCATIONS_ERROR,
				payload: {
					meta: response.meta,
					loading_locations: false
				}
			});
			return;
		}

		const { locations, total } = response.data;

		dispatch({
			type: ActionTypes.GET_DIRECTIONS_LOCATIONS_SUCCESS,
			payload: {
				loading_locations: false,
				total,
				locations
			}
		});
	};
}

export function getNearest(options) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_NEAREST_LOCATION_REQUEST,
			payload: { loading_nearest: true, nearest_location: null }
		});

		const response = await API.directions.getNearest({ ...options });

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_NEAREST_LOCATION_ERROR,
				payload: {
					meta: response.meta,
					loading_nearest: false,
					nearest_location: null
				}
			});
			return;
		}

		const { location, total } = response.data;

		dispatch({
			type: ActionTypes.GET_NEAREST_LOCATION_SUCCESS,
			payload: {
				loading_nearest: false,
				total,
				nearest_location: location
			}
		});
	};
}

export function getBuildingFloorGeojson(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_REQUEST,
			payload: { loading_geojson: true }
		});

		const response = await API.building_floors.getBuildingFloorGeojson(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_GEOJSON_ERROR,
				payload: {
					meta: response.meta,
					loading_geojson: false
				}
			});
			return;
		}

		const { geojson } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_SUCCESS,
			payload: {
				loading_geojson: false,
				floor_geojson: geojson
			}
		});
	};
}

export function getBuildingFloorNavNodes(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_REQUEST,
			payload: { loading_nav_nodes: true }
		});

		const response = await API.building_floors.getBuildingFloorNavNodes(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_GEOJSON_ERROR,
				payload: {
					meta: response.meta,
					loading_nav_nodes: false
				}
			});
			return;
		}

		const { nav_nodes } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_SUCCESS,
			payload: {
				loading_nav_nodes: false,
				nav_nodes
			}
		});
	};
}

export function getBuildingFloorPointOfInterests(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_REQUEST,
			payload: { loading_point_of_interests: true }
		});

		const response = await API.building_floors.getBuildingFloorPointOfInterests(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_GEOJSON_ERROR,
				payload: {
					meta: response.meta,
					loading_point_of_interests: false
				}
			});
			return;
		}

		const { point_of_interests } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_GEOJSON_SUCCESS,
			payload: {
				loading_point_of_interests: false,
				point_of_interests
			}
		});
	};
}

export function getLocationDetailsById(options) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_LOCATION_DETAIL_REQUEST,
			payload: { loading_details: true },
			directions: null
		});

		const response = await API.location_details.getLocationDetailsById(options);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_LOCATION_DETAIL_ERROR,
				payload: {
					meta: response.meta,
					loading_details: false
				}
			});
			return;
		}

		const { location: location_details } = response.data;

		dispatch({
			type: ActionTypes.GET_LOCATION_DETAIL_SUCCESS,
			payload: {
				loading_details: false,
				location_details
			}
		});

		dispatch(getLocationBuildingFloorsById({ building_id: location_details.building_id, limit: 50 }));
		dispatch(getPointOfInterestTypes());
	};
}

export function getDirections(query) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_DIRECTIONS_REQUEST,
			payload: {
				loading_directions: true
			}
		});

		const response = await API.directions.getDirections(query);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_DIRECTIONS_ERROR,
				payload: {
					meta: response.meta,
					loading_directions: false,
					directions: null
				}
			});
			return;
		}

		const { directions } = response.data;
		// const directions = response.data.turf_test.geometry.coordinates;
		dispatch({
			type: ActionTypes.GET_DIRECTIONS_SUCCESS,
			payload: {
				meta: response.meta,
				loading_directions: false,
				directions
			}
		});
	};
}

export function resetMeta() {
	return async dispatch =>
		dispatch({ type: ActionTypes.RESET_DIRECTIONS_META });
};

export function resetPage() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_DIRECTIONS_PAGE });
	};
}